import { FaRegSquare } from 'react-icons/fa';
import { IoBulbOutline } from 'react-icons/io5';
import { MdCenterFocusStrong, MdScreenLockRotation } from 'react-icons/md';
import styled from 'styled-components';

export const ContainerInstructions = styled.div`
  width: 100%;
  height: 300px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BulbIcon = styled(IoBulbOutline)`
  height: 40px;
  width: 40px;
`;

export const RotatePhoneIcon = styled(MdScreenLockRotation)`
  height: 40px;
  width: 40px;
`;

export const RegSquare = styled(FaRegSquare)`
  height: 40px;
  width: 40px;
`;

export const Focus = styled(MdCenterFocusStrong)`
  height: 40px;
  width: 40px;
`;
